var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 18.9095L24.3202 17.6695L24.5202 15.5195L14.1602 16.7795V18.9095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 15.3404L24.6502 14.0604L24.8502 11.9004L14.1602 13.2104V15.3404Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8399 31.8493H14.1699V20.0893L24.0299 18.7793L22.8399 31.8493ZM14.7699 31.2493H22.2899L23.3599 19.4893L14.7699 20.6293V31.2493Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 12.11V0L25.4302 3.37L24.7602 10.72L14.1602 12.12V12.11ZM14.7702 0.810001V11.42L24.2002 10.18L24.7802 3.81L14.7702 0.82V0.810001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0498 21.5697L2.83984 20.9297L3.19984 23.8097L13.0498 24.4197V21.5697Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27979 16.6094L2.64979 19.4794L13.0498 20.1294V17.2794L2.27979 16.6094Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9498 16.1702L1.82979 15.4502L0.779785 7.18016L12.9598 3.66016V16.1702H12.9498ZM2.36979 14.8702L12.3498 15.5202V4.46016L1.44978 7.61016L2.37978 14.8702H2.36979Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 31.8497H3.92004L3.04004 24.9297L12.95 25.5797V31.8497ZM4.46004 31.2497H12.35V26.1497L3.74004 25.5897L4.46004 31.2497Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7002 23.8605L34.8202 22.5105L35.1002 20.7305L24.8702 22.1005L24.7002 23.8605Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3999 27.0202L34.3199 25.6902L34.5799 23.9902L24.5599 25.3302L24.3999 27.0202Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4498 31.8505H24.0498L24.3898 28.2205L34.2498 26.8105L33.4598 31.8505H33.4498ZM24.7098 31.2505H32.9298L33.5198 27.5305L24.9498 28.7605L24.7198 31.2605L24.7098 31.2505Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0698 20.9902L26.3698 7.16016L36.2198 14.2502L35.3898 19.5202L25.0698 20.9902ZM26.8698 8.27016L25.7398 20.2802L34.8598 18.9802L35.5598 14.5202L26.8698 8.26016V8.27016Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.4da563a4a97858bfcbe7ce58cd8c8035.svg";
export { ForwardRef as ReactComponent };